import { cn } from '../../lib/utils';

/**
 * Pine Group 공통 Input 컴포넌트
 */
export function Input({ className, ...props }) {
  return (
    <input
      className={cn(
        'w-full h-9 px-3 rounded-md text-sm',
        'bg-white dark:bg-pine-800 dark:[--autofill-bg:rgb(var(--tw-pine-800))]', // 자동 채우기 덧칠 막을 때 쓸 원래 바탕(autofill.css)
        'border border-[var(--border)] dark:border-pine-600',
        'text-[var(--text)] placeholder:text-[var(--text-muted)]',
        'transition-colors duration-150',
        'focus:outline-none focus:border-accent-500 focus:ring-2 focus:ring-accent-400/20 [--autofill-ring:var(--tw-ring-shadow)]',
        className,
      )}
      {...props}
    />
  );
}

export function Select({ className, children, ...props }) {
  return (
    <select
      className={cn(
        'w-full h-9 px-3 rounded-md text-sm',
        'bg-white dark:bg-pine-800 dark:[--autofill-bg:rgb(var(--tw-pine-800))]',
        'border border-[var(--border)] dark:border-pine-600',
        'text-[var(--text)]',
        'transition-colors duration-150',
        'focus:outline-none focus:border-accent-500 focus:ring-2 focus:ring-accent-400/20 [--autofill-ring:var(--tw-ring-shadow)]',
        className,
      )}
      {...props}
    >
      {children}
    </select>
  );
}

export function Textarea({ className, ...props }) {
  return (
    <textarea
      className={cn(
        'w-full px-3 py-2 rounded-md text-sm',
        'bg-white dark:bg-pine-800 dark:[--autofill-bg:rgb(var(--tw-pine-800))]',
        'border border-[var(--border)] dark:border-pine-600',
        'text-[var(--text)] placeholder:text-[var(--text-muted)]',
        'transition-colors duration-150 resize-y',
        'focus:outline-none focus:border-accent-500 focus:ring-2 focus:ring-accent-400/20 [--autofill-ring:var(--tw-ring-shadow)]',
        className,
      )}
      {...props}
    />
  );
}
